import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonsService} from "@core/service/commons.service";
import {Pagination} from "@core/bean/pagination";
import {NzModalService} from "ng-zorro-antd";
import {DataSyncService} from "../../../routes/jy-srm/supplier/supplier-config/system-config/data-sync/data-sync-service";

@Component({
  selector: 'app-sap-browser-commons',
  templateUrl: './sap-browser-commons.component.html',
  styles: []
})
export class SapBrowserCommonsComponent implements OnInit {
  /**
   *搜索表单
   * 数组，
   * label:搜索名称，
   * value:搜索的字段
   **/
  @Input() searchFormList;

  /**
   *表格展示字段
   * label:展示的字段名称，
   * value:字段名
   **/
  @Input() tableFieldList;
  /**
   * 列表title
   * */
  @Input() title:string;
  /**
   * 配置
   * 对象
   * multiple:是否多选，
   * searchData：对象，初始搜索条件，为pagination的搜索条件,初始搜索条件里面要传objectType，为业务搜索条件,
   * notInitDataBol:打开的时候是否不立即搜索数据
   * */
  @Input() config;
  @Output() private sendData = new EventEmitter();


  visible = false;
  formLoading = false;
  pagination:Pagination = new Pagination();
  searchData:any = {};
  result = [];
  loading = false;
  constructor(private commonsService:CommonsService,
              private modalService:NzModalService,
              private dataSyncService:DataSyncService
  ) {

  }

  ngOnInit() {

  }
  getData() {
    this.loading = true;
    this.dataSyncService.searchFromSap(this.searchData).subscribe(data=> {
      console.log("----------------------------------------");
      console.log(data);
      this.loading = false;
      this.result = data;
    });
  }

  showDataChange(){
    let showNum = this.pagination.page * this.pagination.size;
    if(showNum > this.result.length){
      let beginNum = (this.pagination.page - 1) * this.pagination.size;
      let endNum = this.result.length;
      for(let i = beginNum;i < endNum;i++){
        if(this.result[i]){
          this.result[i].checked = false;
        }
      }
    }else{
      let beginNum = (this.pagination.page - 1) * this.pagination.size;
      let endNum = this.pagination.page * this.pagination.size;
      for(let i = beginNum;i < endNum;i++){
        if(this.result[i]){
          this.result[i].checked = false;
        }
      }
    }
  }

  refreshStatus(e,data){
    if(e && !this.config.multiple){
      let showNum = this.pagination.page * this.pagination.size;
      let showResult:any = [];
      if(showNum > this.result.length){
        showResult = this.result.slice((this.pagination.page - 1) * this.pagination.size,this.result.length);
      }else{
        showResult = this.result.slice((this.pagination.page - 1) * this.pagination.size,this.pagination.page * this.pagination.size);
      }
      showResult.forEach((item) => {
        item.checked = false;
      });
      data.checked = true;
    }
  }


  modalOk() {
    let result = [];
    let showNum = this.pagination.page * this.pagination.size;
    let showResult:any = [];
    if(showNum > this.result.length){
      showResult = this.result.slice((this.pagination.page - 1) * this.pagination.size,this.result.length);
    }else{
      showResult = this.result.slice((this.pagination.page - 1) * this.pagination.size,this.pagination.page * this.pagination.size);
    }
    showResult.forEach((item) => {
      if(item.checked){
        result.push(item);
      }
    });
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.sendData.emit(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.sendData.emit(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  selectData(data) {
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.sendData.emit(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.sendData.emit(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  modalCancel() {
    this.visible = false;
  }

  initData(){
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.searchData = this.config.searchData;
    if(!this.config.notInitDataBol){
      this.getData();
    }
    this.visible = true;
  }
}
